import React, { PureComponent } from "react";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import classnames from "classnames";
import MPSBarLoader from "../../../components/MPSBarLoader";
import { getEmail, getPhone } from "../../../services/FHIR";

export function preprocessLocationData(location) {
  if (!location) {
    return;
  }

  let { address = {}, telecom = [], position = {}, name } = location;

  let phone = getPhone(telecom);
  let email = getEmail(telecom);

  let line = address.line;
  let addressLine1 = "",
    addressLine2 = "";
  if (line) {
    if (line[0]) {
      addressLine1 = line[0];
    }
    if (line[1]) {
      addressLine2 = line[1];
    }
  }

  delete address.line;
  return {
    name,
    ...position,
    email,
    phone,
    ...address,
    addressLine1,
    addressLine2
  };
}

class LocationForm extends PureComponent {
  constructor(props) {
    super(props);
    let location = props.location || {};

    this.state = {
      type: "ADDRESS",
      ...location,
      fieldErrors: {}
    };
  }

  onFormSubmit = e => {
    //todo validations
    e.preventDefault();
    this.setState({ fieldErrors: {} });
    let data = this.state;

    let fieldErrors = {};
    if (this.props.nameField && !data.name) {
      fieldErrors.name = true;
      this.setState({ fieldErrors });
      return;
    }

    let location = {};
    if (data.type === "ADDRESS") {
      let line = [];
      if (data.addressLine1) {
        line.push(data.addressLine1);
      }
      if (data.addressLine2) {
        line.push(data.addressLine2);
      }

      location = {
        telecom: [
          {
            system: "PHONE",
            value: data.phone,
            use: "WORK"
          },
          {
            system: "EMAIL",
            value: data.email,
            use: "WORK"
          }
        ],
        address: {
          use: "WORK",
          line,
          city: data.city,
          country: data.country,
          postalCode: data.postalCode,
          eirCode: data.eirCode
        },
        position: { latitude: data.latitude, longitude: data.longitude },
        type: "BUILDING",
        name: data.name
      };
    } else if (data.type === "LOCATION_CODE") {
      location = {
        address: {
          eirCode: data.eirCode
        },
        name: data.name
      };
    }

    this.props.saveLocation(location);
  };

  render() {
    const { loading, nameField, fullAddress, forDrivers } = this.props;
    const {
      eirCode,
      name,
      phone,
      email,
      addressLine1,
      addressLine2,
      city,
      country,
      postalCode,
      fieldErrors,
      latitude,
      longitude,
      type = "ADDRESS"
    } = this.state;

    return (
      <div>
        <Form style={{ position: "relative" }}>
          {nameField && (
            <FormGroup>
              <Label for="name">Name</Label>
              <div className="inputHolder">
                <input
                  disabled={loading}
                  className={classnames(
                    fieldErrors.name
                      ? "is-invalid form-control"
                      : "form-control"
                  )}
                  value={name}
                  onChange={e => {
                    this.setState({ name: e.target.value });
                  }}
                />
                <div className="invalid-feedback">Please set name</div>
              </div>
            </FormGroup>
          )}

          {!fullAddress && <FormGroup>
            <Label for="name">Enter</Label>
            <div className="inputHolder">
              <span className="mr-4 d-flex align-items-center">
                Address
                <input
                  className="ml-2"
                  type="radio"
                  disabled={loading}
                  checked={type === "ADDRESS"}
                  onChange={e => {
                    this.setState({ type: "ADDRESS" });
                  }}
                />
              </span>

              <span className="d-flex align-items-center">
                Location Code
                <input
                  className="ml-2"
                  type="radio"
                  disabled={loading}
                  checked={type === "LOCATION_CODE"}
                  onChange={e => {
                    this.setState({ type: "LOCATION_CODE" });
                  }}
                />
              </span>
            </div>
          </FormGroup>}

          {type === "LOCATION_CODE" ? (
            <FormGroup>
              <Label for="name">EIR Code</Label>
              <div className="inputHolder">
                <input
                  disabled={loading}
                  className={classnames(
                    fieldErrors.eirCode
                      ? "is-invalid form-control"
                      : "form-control"
                  )}
                  value={eirCode}
                  onChange={e => {
                    this.setState({ eirCode: e.target.value });
                  }}
                />
                <div className="invalid-feedback">Please set location code</div>
              </div>
            </FormGroup>
          ) : (
            <React.Fragment>
              {!this.props.noTelecom && !forDrivers && (
                <FormGroup>
                  <Label for="name">Phone</Label>
                  <div className="inputHolder">
                    <input
                      disabled={loading}
                      className={classnames(
                        fieldErrors.phone
                          ? "is-invalid form-control"
                          : "form-control"
                      )}
                      value={phone}
                      onChange={e => {
                        this.setState({ phone: e.target.value });
                      }}
                    />
                    <div className="invalid-feedback">
                      Please set content phone
                    </div>
                  </div>
                </FormGroup>
              )}

              {!this.props.noTelecom && !forDrivers && (
                <FormGroup>
                  <Label for="name">E-Mail</Label>
                  <div className="inputHolder">
                    <Input
                      disabled={loading}
                      type="email"
                      className={classnames(
                        fieldErrors.title
                          ? "is-invalid form-control"
                          : "form-control"
                      )}
                      value={email}
                      onChange={e => {
                        this.setState({ email: e.target.value });
                      }}
                    />
                    <div className="invalid-feedback">Please set email.</div>
                  </div>
                </FormGroup>
              )}

              <FormGroup>
                <Label for="name">Address</Label>
                <div className="inputHolder">
                  <Input
                    placeholder={"Address Line 1"}
                    disabled={loading}
                    type="text"
                    autoCapitalize="sentences"
                    className={classnames(
                      fieldErrors.addressLine1
                        ? "is-invalid form-control my-1"
                        : "form-control my-1"
                    )}
                    value={addressLine1}
                    onChange={e => {
                      this.setState({ addressLine1: e.target.value });
                    }}
                  />
                  <div className="invalid-feedback">
                    Please set address line 1.
                  </div>

                  <Input
                    placeholder={"Address Line 2"}
                    disabled={loading}
                    type="text"
                    autoCapitalize="sentences"
                    className={"form-control my-1"}
                    value={addressLine2}
                    onChange={e => {
                      this.setState({ addressLine2: e.target.value });
                    }}
                  />

                  <Input
                    placeholder={"City"}
                    disabled={loading}
                    type="text"
                    autoCapitalize="sentences"
                    className={classnames(
                      fieldErrors.city
                        ? "is-invalid form-control my-1"
                        : "form-control my-1"
                    )}
                    value={city}
                    onChange={e => {
                      this.setState({ city: e.target.value });
                    }}
                  />
                  <div className="invalid-feedback">Please set city.</div>

                  <Input
                    placeholder={"Country"}
                    disabled={loading}
                    type="text"
                    autoCapitalize="sentences"
                    className={classnames(
                      fieldErrors.country
                        ? "is-invalid form-control my-1"
                        : "form-control my-1"
                    )}
                    value={country}
                    onChange={e => {
                      this.setState({ country: e.target.value });
                    }}
                  />
                  <div className="invalid-feedback">Please set country.</div>

                  <Input
                    placeholder={"Postal Code"}
                    disabled={loading}
                    type="text"
                    autoCapitalize="sentences"
                    className={classnames(
                      fieldErrors.postalCode
                        ? "is-invalid form-control my-1"
                        : "form-control my-1"
                    )}
                    value={postalCode}
                    onChange={e => {
                      this.setState({ postalCode: e.target.value });
                    }}
                  />
                  <div className="invalid-feedback">
                    Please set Postal Code.
                  </div>

                  {!forDrivers && (
                    <Input
                      placeholder={"EIR Code"}
                      disabled={loading}
                      type="text"
                      autoCapitalize="sentences"
                      className={classnames(
                        fieldErrors.eirCode
                          ? "is-invalid form-control my-1"
                          : "form-control my-1"
                      )}
                      value={eirCode}
                      onChange={(e) => {
                        this.setState({ eirCode: e.target.value });
                      }}
                    />
                  )}
                </div>
              </FormGroup>

              {!forDrivers && (
                <FormGroup>
                  <Label for="name">Location</Label>
                  <div className="inputHolder">
                    <Input
                      placeholder="Latitude"
                      disabled={loading}
                      className={classnames(
                        fieldErrors.addressLine1
                          ? "is-invalid form-control my-1"
                          : "form-control my-1"
                      )}
                      value={latitude}
                      onChange={(e) => {
                        this.setState({ latitude: e.target.value });
                      }}
                    />
                    <div className="invalid-feedback">
                      Please set address line 1.
                    </div>

                    <Input
                      placeholder={"Longitude"}
                      disabled={loading}
                      className={"form-control my-1"}
                      value={longitude}
                      onChange={(e) => {
                        this.setState({ longitude: e.target.value });
                      }}
                    />
                  </div>
                </FormGroup>
              )}
            </React.Fragment>
          )}

          <div
            style={{
              marginTop: 20,
              flex: 1,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center"
            }}
          >
            {loading ? (
              <MPSBarLoader />
            ) : (
              <Button
                color="primary"
                size={"md"}
                className="text-capitalize font-weight-bold"
                type="button"
                onClick={this.onFormSubmit}
              >
                Save
              </Button>
            )}
          </div>
        </Form>
      </div>
    );
  }
}

export default LocationForm;
